export default "__VITE_PUBLIC_ASSET__c9477b98__"